import React from 'react';
import css from './WhoSection.module.css';
import { useHistory } from 'react-router-dom';
import profile from './profile.jpg';

const WhoSection = () => {
  const history = useHistory();
  return (
    <div className={css.wrapper}>
      <div className={css.content}>
        <div className={css.left}>
          <a className={css.link} href="/coming-soon">
            Who's in the spotlight this month? Read more
          </a>
          <p className={css.title}>Meet @Aria.Vox – Rebuilding Rome one scan at a time</p>
          <p className={css.description}>
            From ancient columns to crumbling coins, Aria’s heritage scans are bringing the past to
            life in Unreal Engine 5—and they’re all available now on Scanwow.
          </p>
          <button
            type="button"
            onClick={() => history.push('/coming-soon')}
            className={css.quickActionButton}
          >
            <span>Explore @Aria.Vox’s Creator Profile</span>
          </button>
        </div>
        <div className={css.right}>
          <img src={profile} alt="Aria.Vox Profile" className={css.profileImage} />
        </div>
      </div>
    </div>
  );
};

export default WhoSection;
